import { render, staticRenderFns } from "./ServiceCatalogPage.vue?vue&type=template&id=4e20f90b&scoped=true&"
import script from "./ServiceCatalogPage.vue?vue&type=script&lang=js&"
export * from "./ServiceCatalogPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCatalogPage.vue?vue&type=style&index=0&id=4e20f90b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20f90b",
  null
  
)

export default component.exports